import _ from 'lodash';
import { computed } from 'mobx';
import { LeadBrief } from 'src/generated-api-client';
import { bpmsResourcesManagerApi, leadsApi } from 'src/services/apiServices';
import { InitialFilters } from 'src/stores/LeadsStore/InitialFilters';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { RequestHelper } from 'src/utils/RequestHelper';

export type LeadsFilter = {
    search?: string;
};

export class LeadsStoreClass extends BasicStore<LeadBrief> {
    itemDetailsFormKey = 'embedded:deployment:forms/ap/ap-06-lead.json';

    itemEditFormKey = 'embedded:deployment:forms/ap/ap-07-edit-lead.json';

    itemCreateFormKey = 'embedded:deployment:forms/ap/ap-05-create-lead.json';

    pager = new Pager();

    api: BasicStoreApi<LeadBrief> = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);
            const resp = await RequestHelper.unwrapFromAxiosPromise(
                leadsApi.findAllLeads(
                    this.pager?.page,
                    this.pager.size,
                    InitialFilters.defaultSort,
                    this.filterCriteria.filter.search,
                    options,
                ),
            );

            this.pager.setTotal(resp.totalElements || 0);

            return resp.content || [];
        },
        loadItemForm: (formKey: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm(formKey, options),
            );
        },
        loadItem: (id: number, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                leadsApi.getLead(id, options),
            );
        },
        updateItem: (id, data, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                leadsApi.updateLead(Number(id), data, options),
            );
        },
        createItem: (data, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                leadsApi.createLead(data, options),
            );
        },
    };

    filterCriteria: FilterCriteria<LeadsFilter> = new FilterCriteria();

    @computed get hasFilter() {
        const { search } = this.filterCriteria.filter;

        return !_.isNil(search);
    }
}

export const LeadsStore = new LeadsStoreClass();
